import { useState } from "react";

export function ReferenceFilter({ setFilterDataIndex }) {
	const [selectedOption, setSelectedOption] = useState("All");

	const handleSelectChange = (event) => {
		setSelectedOption(event.target.value);

		switch (event.target.value) {
			case "All":
				setFilterDataIndex(0);
				break;
			case "Employee":
				setFilterDataIndex(1);
				break;
			default:
				setFilterDataIndex(0);
				break;
		}
	};

	return (
		<div className="filters row" style={{ alignItems: "center" }}>
			<span style={{ marginRight: "10px" }}>Filter</span>
			<select
				id=""
				className="filterSelect"
				value={selectedOption}
				onChange={handleSelectChange}
			>
				<option value="All">All</option>
				<option value="Employee">Employee</option>
			</select>
		</div>
	);
}